import { defineComponent as _defineComponent } from 'vue'
import ChatKebabOptions from '@/modules/Chat/components/ChatKebabOptions.vue';
import i18n from '@/i18n';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';

interface Props {
    isNextStepFormActive: boolean;
    loading: boolean;
    isDisabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatMessageActions',
  props: {
    isNextStepFormActive: { type: Boolean },
    loading: { type: Boolean },
    isDisabled: { type: Boolean, default: false }
  },
  emits: ["saveMessage", "cancel", "createActivity"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'saveMessage'): void;
    (e: 'cancel'): void;
    (e: 'createActivity'): void;
}), expose: any, slots: any, attrs: any }) {





const chatActionList = [
    {
        label: i18n.t('Stvori aktivnost'),
        callback: () => {
            EventBus.$emit(EventBusEvents.showCreateActivityForm);
        },
        isVisible: true,
        isDisabled: false,
    },
];

function onSave() {
    emit('saveMessage');
}

function onCancel() {
    emit('cancel');
}

function onCreateActivity() {
    emit('createActivity');
}

return { __sfc: true,emit, chatActionList, onSave, onCancel, onCreateActivity, ChatKebabOptions }
}

})